import axios, { AxiosResponse } from 'axios';

import { IApiListParams, ITeamApiListResponse } from '@/types';

export const loadTeams = (params: IApiListParams): Promise<AxiosResponse<ITeamApiListResponse>> => {
    return axios.get('/api/team/list', { params });
};

export const addFavoriteTeam = (ctId: number) => {
    return axios.post('/api/favoriteTeam/create', { rows: [{ ctId }] });
};

export const removeFavoriteTeam = (ctId: number) => {
    return axios.post('/api/favoriteTeam/delete', { rows: [{ id: ctId }] });
};
